import { useIdValidation } from 'features/customerPanel/accountVerification/hook/useIdValidation';
import { VerificationFormData } from 'features/customerPanel/accountVerification/interface/verification';
import { FormikErrors, FormikTouched } from 'formik';
import React, { lazy, Suspense } from 'react';
import { TFunction } from 'react-i18next';
import FormRow from 'shared/components/form/formRow';
import FormSubTitle from 'shared/components/form/formSubTitle';
import InputText from 'shared/components/form/inputText';
import useInputFocus from 'shared/hooks/useInputFocus';
import { isFieldValueValid } from 'shared/util/utility';

const InputDatePicker = lazy(() => import('shared/components/form/inputDatePicker'));

interface Props {
	t: TFunction<'translation'>;
	values: VerificationFormData;
	errors: FormikErrors<{ [field: string]: any }>;
	touched: FormikTouched<{}>;
	setFieldError: (field: string, val: any) => void;
	handleBlur: (e: React.FocusEvent<any>) => void;
	setFieldValue: (field: string, val: any) => void;
}

const AccountVerificationFormStep6: React.FC<Props> = ({ t, values, errors, touched, setFieldError, handleBlur, setFieldValue }) => {
	const minDate = new Date();
	minDate.setDate(minDate.getDate() + 1);
	const { documentValidationMessage, validateId } = useIdValidation();
	const inputRef = useInputFocus();

	return (
		<>
			<FormSubTitle title={t('verificationGenericTitle')} />
			<FormRow>
				<InputText
					name="seriesNumber"
					label={t('seriesNumber')}
					inputRef={inputRef}
					values={values}
					onBlur={handleBlur}
					errors={errors}
					isFieldValueValid={isFieldValueValid}
					touched={touched}
					setFieldValue={setFieldValue}
					additionalError={documentValidationMessage}
					onChange={(e: any) => {
						let val = e.target.value;
						if (val)
							val = val
								.trim()
								.replace(/[^0-9a-zA-Z ]/g, '')
								.toUpperCase();
						setFieldValue('seriesNumber', val);
						setFieldError('seriesNumber', documentValidationMessage);
						validateId(val);
					}}
					cyTestRef="series-number"
					cyErrorRef="validation-error"
				/>
			</FormRow>
			<FormRow>
				<Suspense fallback={<></>}>
					<InputDatePicker
						name="expirationDate"
						id="expirationDate"
						label={t('expirationDate')}
						touched={touched}
						minDate={minDate}
						isFieldValueValid={isFieldValueValid}
						setFieldValue={setFieldValue}
						setFieldError={setFieldError}
						errors={errors}
						values={values}
						handleBlur={handleBlur}
						cyTestRef="expire-date"
						cyErrorRef="validation-error"
					/>
				</Suspense>
			</FormRow>
		</>
	);
};

export default AccountVerificationFormStep6;
